import { render } from "./remove.vue?vue&type=template&id=6a63bb50&scoped=true&ts=true"
import script from "./remove.vue?vue&type=script&lang=ts"
export * from "./remove.vue?vue&type=script&lang=ts"

import "./remove.vue?vue&type=style&index=0&id=6a63bb50&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a63bb50"]])

export default __exports__